import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import "./i18n"; // Import i18n configuration
import { initWebMCP } from "./utils/webmcp";

// No-op on browsers without navigator.modelContext — see webmcp.js.
initWebMCP();

// If react-snap has pre-rendered the page at build time, the #root div
// already contains real DOM. In that case we MUST hydrate instead of
// re-rendering, otherwise React 19 wipes the SEO markup before the user
// (or crawler) sees it. Detection: pre-rendered snapshots do NOT carry
// the `data-seo-fallback` attribute (react-snap replaces the DOM after
// React mounts, so the attribute is gone). Dev / static index.html DO
// carry it — so we treat those as fresh renders (`createRoot`), which
// correctly REPLACES the SEO fallback content when the SPA boots.
const rootEl = document.getElementById("root");
const isPrerendered = rootEl.getAttribute("data-seo-fallback") !== "true";

if (isPrerendered) {
  ReactDOM.hydrateRoot(
    rootEl,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Wipe SEO fallback children so createRoot starts from a clean slate.
  rootEl.innerHTML = "";
  // Also drop the marker attribute itself — the pre-hydration critical CSS
  // in index.html keys off `#root[data-seo-fallback="true"] > *` to hide
  // the fallback/boot-loader content. React only manages children, not
  // attributes on the container it's told to render into, so this
  // attribute would otherwise persist forever and keep hiding the real
  // app after it mounts.
  rootEl.removeAttribute("data-seo-fallback");
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
